import React from 'react';
import { useTranslation } from 'react-i18next';

import { isDefault } from '../../../utils/template';

import { LotteryDrawRecord } from 'Api/SiteApi/Responses';
import DrawName from 'components/common/DrawName';
import { formatLongWithTimezone } from 'utils/formatters';

type Props = Readonly<{
    lotteryDraw: LotteryDrawRecord | null;
    timezone: string | null;
}>;

function ResultsDate({ lotteryDraw, timezone }: Props) {
    const { t } = useTranslation();

    return (
        <div className="col-md col-12 draw-date-wrapper">
            <div className={`draw-date ${isDefault ? 'text-center' : ''}`}>
                {t('draw.eventDate')}:{' '}
                <span className={isDefault ? 'fw-bold' : 'font-bold'}>
                    <DrawName value={lotteryDraw?.draw_name} />
                    <time className="font-bold" dateTime={lotteryDraw?.date}>
                        {formatLongWithTimezone(lotteryDraw?.date, timezone)}
                    </time>
                </span>
            </div>
        </div>
    );
}

export default ResultsDate;
